import { baseUrl } from 'infra/config/aws-env'
import { UserInternalService } from 'infra/services/user-internal-service'
import { makeAxiosHttpClient } from '../http/axios-http-client-factory'

export const makeUserInternalService = (): UserInternalService =>
  new UserInternalService(baseUrl, makeAxiosHttpClient())
